import { isNil } from 'es-toolkit';

/**
 * Triggers a file download in the browser.
 */
export function downloadFile(content: string | Blob, filename: string, mimeType: string): void {
  const blob = content instanceof Blob ? content : new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = sanitizeFilename(filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
}

/**
 * Downloads a file from a URL.
 */
export function downloadFromURL(url: string, filename?: string): void {
  // Validate URL scheme to prevent XSS
  try {
    const parsedUrl = new URL(url, window.location.origin);
    if (!['http:', 'https:', 'blob:'].includes(parsedUrl.protocol)) {
      throw new Error(`Unsafe URL protocol: ${parsedUrl.protocol}`);
    }
  } catch (error) {
    console.error('Invalid or unsafe download URL:', error);
    return;
  }

  const link = document.createElement('a');
  link.href = url;
  if (!isNil(filename)) {
    link.download = sanitizeFilename(filename);
  }
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

function sanitizeFilename(filename: string): string {
  return filename.replace(/[/\\]/g, '_').replace(/^\.+/, '');
}
